import { getAttrValue, getLocalizedString } from "@grandvisionhq/utils";
const getProductTitle = (lineItemProduct, intl) => {
  const brand = getAttrValue(lineItemProduct.masterData.current.variant, "brand");
  return brand ? String(brand) : getLocalizedString(lineItemProduct.masterData.current.name, intl.locale);
};
export {
  getProductTitle
};
//# sourceMappingURL=get-product-title.js.map
